import axios from "axios";
import { getLastActivity } from "./sessionActivity";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Session timeout: tell the server when the user was last genuinely
// active (background polls carry the same old stamp, so they can't
// extend the session). A server-side idle expiry signs every tab out.
api.interceptors.request.use((config) => {
  const last = getLastActivity();
  if (last) config.headers["X-Activity-At"] = String(last);
  return config;
});
const SESSION_END_DETAILS = ["expired due to inactivity", "You have been signed out"];
api.interceptors.response.use(undefined, (err) => {
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 401 && typeof detail === "string"
      && SESSION_END_DETAILS.some((d) => detail.includes(d))) {
    window.dispatchEvent(new CustomEvent("cpg:session-expired"));
  }
  return Promise.reject(err);
});

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  // Structured error objects — backends may use `.message` (our
  // plan_gated / 402 payloads) or `.msg` (FastAPI validation).
  // Prefer either readable string over stringifying the whole
  // object, which used to leak `{"kind":"plan_gated","message":"…"}`
  // into user-facing toasts / lock screens.
  if (typeof detail === "object") return detail.message || detail.msg || JSON.stringify(detail);
  return String(detail);
}
